import { z } from "zod";

export const schemaGroup = z.object({
	id_complementos_grupo: z.number().int().optional(),
	ordem: z.preprocess(
		(val) => {
			if (typeof val === "string") return parseInt(val, 10) || 0;
			return val;
		},
		z.number().int("A ordem deve ser um número inteiro").min(0, "A ordem deve ser 0 ou maior"),
	),
	qtde_max_escolha: z.preprocess(
		(val) => {
			if (typeof val === "string") return parseInt(val, 10) || 0;
			return val;
		},
		z.number().int("A quantidade deve ser um número inteiro").min(0, "A quantidade deve ser 0 ou maior"),
	),
	obs: z.string().optional(),
	descricao: z.string().min(1, "O campo descrição é obrigatório"),
	ativo: z.boolean(),
	obrigatorio: z.boolean(),
	subitem: z.boolean().optional(),
}).superRefine((data, ctx) => {
	if (data.subitem) {
		if (data.qtde_max_escolha <= 0) {
			ctx.addIssue({
				code: z.ZodIssueCode.custom,
				message: "A quantidade máxima deve ser maior que zero quando for Subitem",
				path: ["qtde_max_escolha"],
			});
		}
		if (!data.obrigatorio) {
			ctx.addIssue({
				code: z.ZodIssueCode.custom,
				message: "A seleção deve ser Obrigatória para grupos do tipo Subitem",
				path: ["obrigatorio"],
			});
		}
	}
});
